import { z } from "zod";
import { menuSchema } from "./menu";

export const configSchema = z.object({
  menu: menuSchema,
});
